var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        class: _vm.classe,
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          dense: _vm.dense,
          disabled: _vm.disabled || !_vm.dayOfWeekId || !_vm.companyId,
          "return-object": true,
          hideDetails: _vm.hideDetails,
          classe: _vm.classe,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }